// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2ZEwG","resendInfoText":"OnGoingPaymentBox_resendInfoText__3KxvY"};